// utils/Toast.js
import React, { useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Custom ToastContainer without close button
export const ToastProvider = () => {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false} // IMPORTANT: Change to false
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      limit={3}
      closeButton={false} // Disable close button
    />
  );
};

// Custom toast functions without the bug
class ToastManager {
  constructor() {
    this.currentToastId = null;
  }

  success(message, options = {}) {
    this.dismissCurrent();
    
    const toastId = toast.success(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      ...options
    });
    
    this.currentToastId = toastId;
    return toastId;
  }

  error(message, options = {}) {
    this.dismissCurrent();
    
    const toastId = toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      ...options
    });
    
    this.currentToastId = toastId;
    return toastId;
  }

  info(message, options = {}) {
    this.dismissCurrent();
    
    const toastId = toast.info(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      ...options
    });
    
    this.currentToastId = toastId;
    return toastId;
  }

  warning(message, options = {}) {
    this.dismissCurrent();
    
    const toastId = toast.warning(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      ...options
    });
    
    this.currentToastId = toastId;
    return toastId;
  }

  loading(message, options = {}) {
    this.dismissCurrent();
    
    const toastId = toast.loading(message, {
      position: "bottom-right",
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
      theme: "light",
      ...options
    });
    
    this.currentToastId = toastId;
    return toastId;
  }

  dismiss(id = null) {
    if (id) {
      toast.dismiss(id);
      if (this.currentToastId === id) {
        this.currentToastId = null;
      }
    } else if (this.currentToastId) {
      toast.dismiss(this.currentToastId);
      this.currentToastId = null;
    }
  }

  update(id, options) {
    toast.update(id, options);
  }

  dismissCurrent() {
    if (this.currentToastId) {
      toast.dismiss(this.currentToastId);
      this.currentToastId = null;
    }
  }
}

// Create single instance
const toastManager = new ToastManager();

export default toastManager;